import script from "./Caap101Practice.vue?vue&type=script&setup=true&lang=js"
export * from "./Caap101Practice.vue?vue&type=script&setup=true&lang=js"

import "./Caap101Practice.vue?vue&type=style&index=0&id=4b734270&lang=css"

const __exports__ = script;

export default __exports__